import type { ProjectStatus, ProjectType } from '@/types/project';

export const PROJECT_STATUS = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
} as const satisfies Record<string, ProjectStatus>;

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  ACTIVE: '进行中',
  ARCHIVED: '已归档',
};

export const PROJECT_TYPE = {
  ENGINEERING: 'ENGINEERING',
  INVESTMENT: 'INVESTMENT',
  KEY_PROJECT: 'KEY_PROJECT',
  TEMPORARY: 'TEMPORARY',
  OTHER: 'OTHER',
} as const satisfies Record<string, ProjectType>;

export const PROJECT_TYPE_LABELS: Record<ProjectType, string> = {
  ENGINEERING: '工程类',
  INVESTMENT: '投资类',
  KEY_PROJECT: '重点项目',
  TEMPORARY: '临时项目',
  OTHER: '其他',
};

export const PROJECT_TYPE_OPTIONS = Object.entries(PROJECT_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}));
